/** The property -> active-transaction resolution, plus the list price derived from it.
 *
 * `resolvePropertyListPrice` sits HERE rather than in a leaf of its own: it is an eight-line reader whose ONLY
 * dependency is `resolveTransaction` below, and a separate `utils/` leaf could not value-import that sibling
 * (`QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001`), so the leaf that owns the dependency is its home. */

import type { Property } from '@federa/types/properties';
import type { Transaction } from '@federa/types/properties-transaction';

export function resolveTransaction(property?: Property | null): Transaction | null {
	if (!property) return null;
	if (property.matchingActiveTransaction) return property.matchingActiveTransaction;
	if (property.transactionsListActive && property.transactionsListActive.length > 0) {
		return property.transactionsListActive[0] ?? null;
	}
	if (property.transactionsList && property.transactionsList.length > 0) {
		return property.transactionsList[0] ?? null;
	}
	return null;
}

/** Resolve the listing price for a property: transaction listPrice -> askPrice -> last -> 0. */
export function resolvePropertyListPrice(property: Property): number {
	const transactionPrice = resolveTransaction(property)?.listPrice;
	if (transactionPrice) return transactionPrice;
	if (property.askPrice) return property.askPrice;
	if (property.last) return property.last;
	return 0;
}
